import { Permissions } from '../../core-module/constants/permission.constants';

export interface ManagementFeature {
  id: number;
  name: string;
  navCommands: string[];
  icon: string;
  roles?: string[];
  permissions?: string[];
}

const LOAN_TEAM_MODULE_ACCESS = {
  permissions: [
    Permissions.Pipeline.Loan.FullControl,
    Permissions.Payroll.Payroll.FullControl,
    Permissions.Management.LoanTeam.Read,
    Permissions.Management.LoanTeam.FullControl
  ]
};

const BRANCH_MODULE_ACCESS = {
  permissions: [
    Permissions.Management.Branch.FullControl,
    Permissions.Pipeline.Loan.FullControl
  ]
};

const USER_MODULE_ACCESS = {
  permissions: [
    Permissions.Management.User.FullControl
  ]
};

const BORROWER_MODULE_ACCESS = {
  permissions: [
    Permissions.Management.Borrower.FullControl
  ]
};

const LENDER_MODULE_ACCESS = {
  permissions: [
    Permissions.Management.Lender.FullControl
  ]
};

const MARKETING_MODULE_ACCESS = {
  permissions: [
    Permissions.MarketingHub.MarketingResource.FullControl
  ]
};

const ROLE_MODULE_ACCESS = {
  permissions: [
    Permissions.Management.Role.FullControl
  ]
};

export const MANAGEMENT_FEATURES: ManagementFeature[] = [
  { id: 1, name: 'Loan Officers', navCommands: ['/loan-officers'], icon: 'supervisor_account', ...LOAN_TEAM_MODULE_ACCESS },
  { id: 2, name: 'Processors', navCommands: ['/processors'], icon: 'engineering', ...LOAN_TEAM_MODULE_ACCESS },
  { id: 3, name: 'Funders', navCommands: ['/funders'], icon: 'account_balance', ...LOAN_TEAM_MODULE_ACCESS },
  { id: 4, name: 'LOAs', navCommands: ['/loas'], icon: 'assignment_ind', ...LOAN_TEAM_MODULE_ACCESS },
  { id: 5, name: 'Branches', navCommands: ['/branches'], icon: 'apartment', ...BRANCH_MODULE_ACCESS },
  { id: 6, name: 'Users', navCommands: ['/users'], icon: 'group', ...USER_MODULE_ACCESS },
  { id: 7, name: 'Borrowers', navCommands: ['/borrowers'], icon: 'person_search', ...BORROWER_MODULE_ACCESS },
  { id: 8, name: 'Lenders', navCommands: ['/lenders'], icon: 'account_balance_wallet', ...LENDER_MODULE_ACCESS },
  { id: 9, name: 'Media Resources', navCommands: ['/media-resources/resources'], icon: 'perm_media', ...MARKETING_MODULE_ACCESS },
  { id: 10, name: 'Roles', navCommands: ['/roles'], icon: 'admin_panel_settings', ...ROLE_MODULE_ACCESS },
] as const;